const BASE_URL = 'http://localhost:8080';

export const awsService = {
  async connectAWS(roleArn) {
    try {
      // Get the JWT token from localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      console.log('Connecting AWS with role ARN:', roleArn);
      const response = await fetch(`${BASE_URL}/integrations/aws`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          role_arn: roleArn
        }),
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('AWS connection error:', {
          status: response.status,
          statusText: response.statusText,
          errorData
        });
        throw new Error(errorData.detail || 'Failed to connect AWS account');
      }
      
      const data = await response.json();
      console.log('AWS connection success:', data);
      return data;
    } catch (error) {
      console.error('Error connecting AWS:', error);
      throw error;
    }
  }
}; 